import React, { useState, useEffect } from "react";
import { Card, Form, Input, Button, Row, Col, message } from "antd";
import { useSelector } from "react-redux";
import { CheckOutlined, CloseOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import 'antd/dist/antd.css';
import ProfileService from "../../../../../services/Profile/ProfileService";



const Edit = ({ id, socialAccounts, onClose, onSuccess }) => {
    const token = useSelector((state) => state.Member.token);
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();


    useEffect(() => {
        socialAccounts.map((elm, index) =>
            form.setFieldsValue({
                ["account_name_" + elm.name]: elm.account_name,
                ["user_url_" + elm.name]: elm.user_url,
            })
        );
    }, [form, socialAccounts]);


    const formatRequestData = (data) => {
        let socialAccountsSend = [];

        socialAccounts.forEach((elm, index) => {
            let account_name = data["account_name_" + elm.name];
            let user_url = data["user_url_" + elm.name];

            const accountObject = {
                socialmedia_id: elm.id,
                account_name: account_name,
                user_url: user_url,
            };

            socialAccountsSend.push(accountObject);
        });

        const requestData = {
            member: id,
            social_accounts: socialAccountsSend,
        };

        return requestData;
    };


    const onSave = () => {
        setLoading(true);
        form
            .validateFields()
            .then((data) => {
                const requestData = formatRequestData(data);
                ProfileService.addSocialAccounts(token, requestData)
                    .then((response) => {
                        message.success("Modifikimi u krye me sukses!", 1).then(() => {
                            setLoading(false);
                            onSuccess();
                        });
                    })
                    .catch((err) => {
                        const errorMessage = err.response.data.Error
                            ? err.response.data.Error
                            : "Një gabim ndodhi gjatë modifikimit!";
                        message.error(errorMessage, 3).then(() => {
                            setLoading(false);
                        });
                    });
            }).catch(() => { setLoading(false); });
    };


    return (
        <Row gutter={24}>
            <Col span={24}>
                <Card
                    style={{ border: "none", backgroundColor: "#00000009", color: "#000" }}
                    bodyStyle={{ padding: "15px" }}
                >
                    <Row gutter={24} align="middle">
                        <Col xl={4} lg={4} md={0} sm={0} xs={0}></Col>
                        <Col xl={16} lg={16} md={0} sm={0} xs={0} className="text-center">
                            <h4 className="m-0 p-0" style={{ color: "#000" }}>
                                Jeni duke modifikuar të dhënat për rrjetet sociale
                            </h4>
                        </Col>
                        <Col xl={4} lg={4} md={0} sm={0} xs={0} className="text-right" >
                            <Button type="primary" ghost onClick={onClose} icon={<ArrowLeftOutlined />}>Kthehu</Button>
                        </Col>
                    </Row>
                </Card>
                <Form
                    form={form}
                    labelCol={{ span: 6 }}
                    labelAlign="left"
                    layout="horizontal"
                >
                    <Row gutter={24} className="mt-3 ">
                        {socialAccounts.map((elm, index) => (
                            <Col xl={24} lg={24} md={24} sm={24} xs={24} key={index}>
                                <Card
                                    style={{ borderRadius: "10px" }}
                                    className={index !== 0 && "mt-2"}
                                    bodyStyle={{ padding: "15px" }}
                                >
                                    <Row gutter={24} className="p-0 m-0" align="middle">
                                        <Col xl={4} lg={4} md={4} sm={24} xs={24} className="p-0 m-0">
                                            {elm.name === "Facebook" ? (
                                                <img
                                                    alt="Facebook Logo"
                                                    src="/img/fb-logo.png"
                                                    style={{
                                                        width: "100%",
                                                        height: "100px",
                                                        borderRadius: "15px",
                                                    }}
                                                />
                                            ) : elm.name === "Twitter" ? (
                                                <img
                                                    alt="Twitter Logo"
                                                    src="/img/twitter-logo.png"
                                                    style={{
                                                        width: "100%",
                                                        height: "100px",
                                                        borderRadius: "15px",
                                                    }}
                                                />
                                            ) : (
                                                elm.name === "Instagram" && (
                                                    <img
                                                        alt="Instagram Logo"
                                                        src="/img/instagram-logo.png"
                                                        style={{
                                                            width: "100%",
                                                            height: "100px",
                                                            borderRadius: "15px",
                                                        }}
                                                    />
                                                )
                                            )}
                                        </Col>
                                        <Col xl={2} lg={2} md={2} sm={24} xs={24}></Col>
                                        <Col xl={12} lg={12} md={12} sm={24} xs={24}>
                                            <Form.Item
                                                name={"account_name_" + elm.name}
                                                label="Emri i llogarisë:"
                                                className="p-0 m-0 mt-2"
                                            >
                                                <Input type="text" />
                                            </Form.Item>
                                            <Form.Item
                                                name={"user_url_" + elm.name}
                                                label="User url:"
                                                className="p-0 m-0 mt-2"
                                            >
                                                <Input type="text" />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                    <Row gutter={24} align="middle" className="mt-3 mb-3">
                        <Col xl={24} lg={24} md={24} sm={24} xs={24} className="text-center">
                            <Button
                                type="primary"
                                className="mr-4"
                                onClick={onSave}
                                loading={loading}
                                icon={<CheckOutlined />}
                                size="medium"
                            >
                                Ruaj
                            </Button>
                            <Button
                                danger
                                onClick={onClose}
                                icon={<CloseOutlined />}
                                size="medium"
                            >
                                Mbyll
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </Col>
        </Row>
    );
};


export default Edit;